module.exports = __webpack_public_path__ + "static/teema-2ea6a98746ba1f96df51f140740d34c1.png";